import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const SearchTemplate = htmlE`
  <style>
    .search-modal .grid-search-modal-wrapper {
      display: grid;
      gap: 1rem;
      margin-top: 1rem;
    }

    .search-modal .grid-search-modal-wrapper .grid-search-modal {
      display: grid;
      gap: 2rem;
      grid-template-columns: 100px 150px auto;
      align-items: center;
    }

    .search-modal .grid-search-modal-wrapper .date-input,
    .search-modal .grid-search-modal-wrapper .kb-input {
      max-width: 200px;
    }

    .search-modal .search-modal-keyword-wrapper {
      gap: 0.5rem;
    }

    .search-modal .search-modal-keyword-wrapper .keyword-input label {
      max-width: 250px;
      white-space: nowrap;
    }

    .search-modal .search-modal-keyword-wrapper .keyword-input input {
      min-width: 150px;
      max-width: 250px;
      margin-left: 0.5rem;
    }

    .search-modal .search-modal-keyword-wrapper .keywords-only-wrapper label {
      min-width: 100px;
    }
  </style>

  <form id="searchModalForm" class="search-modal">
    <div
      class="is-flex is-align-items-center is-justify-content-space-between search-modal-keyword-wrapper">
      <div
        class="is-flex is-align-items-center is-justify-content-space-between keyword-input">
        <label data-i18n-key="keywords">keywords :</label>
        <input name="keyword" class="input modal-input" />
      </div>

      <div
        class="is-flex is-align-items-center is-justify-content-space-between">
        <div class="is-flex is-align-items-center">
          <input
            id="orSearch"
            checked
            name="include_type"
            type="radio"
            value="or" />
          <label
            data-i18n-key="or"
            for="orSearch"
            class="text-sm text-primaryMain px-2">
            or
          </label>
        </div>
        <div class="is-flex is-align-items-center">
          <input id="andSearch" name="include_type" type="radio" value="and" />
          <label
            data-i18n-key="and"
            for="andSearch"
            class="text-sm text-primaryMain px-2">
            and
          </label>
        </div>
      </div>

      <div
        class="is-flex is-align-items-center is-justify-content-space-between">
        <div class="is-flex is-align-items-center">
          <input id="exactSearch" name="exact" value="true" type="checkbox" />
          <label
            data-i18n-key="exact"
            for="exactSearch"
            class="text-sm text-primaryMain px-2">
            exact?
          </label>
        </div>

        <div
          class="is-flex is-align-items-center whitespace-nowrap is-clipped is-ellipsis keywords-only-wrapper">
          <input
            id="keywordsOnlySearch"
            name="keywords_only"
            value="true"
            type="checkbox" />
          <label
            data-i18n-key="searchKeywordOnly"
            for="keywordsOnlySearch"
            class="text-sm text-primaryMain px-2">
            searchKeywordOnly
          </label>
        </div>
      </div>
    </div>

    <div class="grid-search-modal-wrapper">
      <div class="grid-search-modal">
        <div class="is-flex is-align-items-center">
          <input
            name="date1"
            id="modifiedSearch1"
            value="true"
            type="checkbox" />
          <label
            data-i18n-key="modified"
            for="modifiedSearch1"
            class="text-sm text-primaryMain px-2">
            modified
          </label>
        </div>
        <div>
          <div class="select">
            <select name="date1_action" class="primary-select">
              <option selected data-i18n-key="after" value="after">
                after
              </option>
              <option data-i18n-key="before" value="before">before</option>
            </select>
          </div>
        </div>
        <div>
          <input
            id="modified-1"
            name="date1_value"
            class="input modal-input date-input"
            type="date" />
          (${"dateFormatText"})
        </div>
      </div>

      <div class="grid-search-modal">
        <div class="is-flex is-align-items-center">
          <input name="date2" id="dateSearch2" value="true" type="checkbox" />
          <label
            data-i18n-key="modified"
            for="dateSearch2"
            class="text-sm text-primaryMain px-2">
            modified
          </label>
        </div>
        <div>
          <div class="select">
            <select name="date2_action" class="primary-select">
              <option selected data-i18n-key="after" value="after">
                after
              </option>
              <option data-i18n-key="before" value="before">before</option>
            </select>
          </div>
        </div>
        <div>
          <input
            name="date2_value"
            id="modified-2"
            class="input modal-input date-input"
            type="date" />
          (${"dateFormatText"})
        </div>
      </div>

      <div class="grid-search-modal">
        <div class="is-flex is-align-items-center">
          <input name="size1" id="sizeSearch1" value="true" type="checkbox" />
          <label
            data-i18n-key="sizeIs"
            for="sizeSearch1"
            class="text-sm text-primaryMain px-2">
            sizeIs
          </label>
        </div>
        <div>
          <div class="select">
            <select name="size1_action" class="primary-select">
              <option selected data-i18n-key="biggerThan" value="bigger than">
                biggerThan
              </option>
              <option data-i18n-key="smallerThan" value="smaller than">
                smallerThan
              </option>
            </select>
          </div>
        </div>
        <div>
          <input
            name="size1_value"
            id="size-1"
            class="input modal-input kb-input" />
          (
          <span data-i18n-key="kilobytes">kilobytes</span>
          )
        </div>
      </div>

      <div class="grid-search-modal">
        <div class="is-flex is-align-items-center">
          <input name="size2" id="sizeSearch2" value="true" type="checkbox" />
          <label
            data-i18n-key="sizeIs"
            for="sizeSearch2"
            class="text-sm text-primaryMain px-2">
            sizeIs
          </label>
        </div>
        <div>
          <div class="select">
            <select name="size2_action" class="primary-select">
              <option data-i18n-key="biggerThan" value="bigger than">
                biggerThan
              </option>
              <option selected data-i18n-key="smallerThan" value="smaller than">
                smallerThan
              </option>
            </select>
          </div>
        </div>
        <div>
          <input
            name="size2_value"
            id="size-2"
            class="input modal-input kb-input" />
          (
          <span data-i18n-key="kilobytes">kilobytes</span>
          )
        </div>
      </div>

      <div class="grid-search-modal">
        <div class="is-flex is-align-items-center">
          <input name="type1" id="typeSearch1" value="true" type="checkbox" />
          <label
            data-i18n-key="typeIsA"
            for="typeSearch1"
            class="text-sm text-primaryMain px-2">
            typeIsA
          </label>
        </div>
        <div>
          <div class="select">
            <select name="type1_action" class="primary-select">
              <option selected data-i18n-key="file" value="file">file</option>
              <option data-i18n-key="folder" value="folder">folder</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <button type="submit" class="is-hidden"></button>
  </form>
`;

export const searchPollingTemplate = htmlE`
  <div>
    <div
      class="is-flex is-justify-content-center is-align-items-center gap-3 mb-3">
      <span>
        <span data-i18n-key="searching">Searching</span>
        <span>...</span>
      </span>
      <button
        id="abortSearchAction"
        class="primary-button is-bg-none p-0"
        data-i18n-key="cancel">
        Cancel
      </button>
    </div>

    <progress
      class="progress success-progress poll-search-status-progress"
      value="0"
      max="100"></progress>
  </div>
`;

export default SearchTemplate;
